import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { tv } from "tailwind-variants";

const labelVariants = tv({
  slots: {
    container: "mb-1.5 flex items-center gap-1",
    label: "m-0 text-sm leading-5 font-medium text-content-strong",
    requiredMark: "text-danger-content",
  },
  variants: {
    disabled: {
      true: { label: "text-content-subtle" },
    },
  },
});

const { container, label: labelClass, requiredMark } = labelVariants();

export type LabelProps = {
  label: ReactNode;
  containerClassName?: string;
  disabled?: boolean;
  required?: boolean;
} & ComponentPropsWithoutRef<"label">;

export const Label = ({
  className,
  containerClassName,
  disabled,
  label,
  required = false,
  ...props
}: LabelProps) => {
  return (
    <div className={container({ className: containerClassName })}>
      <label {...props} className={labelClass({ className, disabled })}>
        {label}
      </label>

      {required ? (
        <span aria-hidden="true" className={requiredMark()}>
          *
        </span>
      ) : null}
    </div>
  );
};
